import { AppModal } from '@/components/shared/modal'

import { MODAL_TITLE_PROBLEM_NOT_SOLVED } from './model/constants'
import { ProblemNotSolvedForm } from './ProblemNotSolvedForm'
import { RequestRatingHeader } from './RequestRatingHeader'
import { ModalName } from './types/types'

type Props = {
  id: string
  visible: boolean
  onClose: () => void
  setModalName: (_: ModalName) => void
  refetchRequest: () => void
}

const ProblemNotSolvedModal = ({
  id,
  visible,
  onClose,
  setModalName,
  refetchRequest
}: Props) => (
  <AppModal
    header={<RequestRatingHeader title={MODAL_TITLE_PROBLEM_NOT_SOLVED} />}
    opened={visible}
    onClose={onClose}
  >
    <ProblemNotSolvedForm
      id={id}
      onClose={onClose}
      setModalName={setModalName}
      refetchRequest={refetchRequest}
    />
  </AppModal>
)

export { ProblemNotSolvedModal }
